<template>
    <div class="sidebar">
      <el-scrollbar>
        <el-menu :default-active="$route.path" @open="handleOpen" @close="handleClose" :background-color="menuBackgroundColor" :text-color="menuTextColor"
          active-text-color="#ffd04b" router mode="horizontal">
          <common-menu-item-aside v-for="(child, index) in menuData" :key="child.path + index" :item="child"
            :isTitle="true"></common-menu-item-aside>
        </el-menu>
      </el-scrollbar>
    </div>
  </template>
  
  <script>
  import logoImg from '@/assets/logo.png'
  import { SYSTEM_NAME } from "@/constant/Const";
  import CommonMenuItemAside from "./CommonMenuItemAside.vue";
  import { mapState } from 'vuex';
  
  export default {
    name: "CommonMenuAside",
    components: {
      CommonMenuItemAside,
    },
    data() {
      return {
        systemName: SYSTEM_NAME,
        logo: logoImg,
        width: "200px",
      };
    },
    methods: {
      handleOpen(key, keyPath) {
        // console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath);
      },
    },
    computed: {
      noChildren() {
        return this.menuData.filter((item) => !item.children);
      },
      hasChildren() {
        return this.menuData.filter((item) => item.children);
      },
      menuData() {
        return this.$store.state.tab.menuList;
      },
      topValue() {
        return this.$store.state.settings.topValue;
      },
      // Extract background color logic based on sideValue
      menuBackgroundColor() {
        return this.topValue === 'darkColor' ? '#2b2f3a' : '#fff';
      },
      // Extract text color logic based on sideValue
      menuTextColor() {
        return this.topValue === 'darkColor' ? '#fff' : 'rgba(0, 0, 0, 0.88)';
      },
      // Extract class for logo text style
      logoClass() {
        return this.topValue;
      },
      // 侧边栏宽度
      sideWidth() {
        this.width = this.$store.state.settings.sideWidth + 'px';
        return this.$store.state.settings.sideWidth;
      },
    },
    mounted() {
      const storedMenuList = JSON.parse(window.sessionStorage.getItem("menuList"));
      if (storedMenuList) {
        this.$store.dispatch('updateMenuList', storedMenuList);
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  
  .sidebarLogoFade-enter-active,
  .sidebarLogoFade-leave-active {
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  }
  
  .sidebarLogoFade-enter {
    opacity: 0;
    transform: translateY(-10px);
  }
  
  .sidebarLogoFade-leave-to {
    opacity: 0;
    transform: translateY(10px);
  }
  
  .logo {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .el-menu ::v-deep {
    width: calc(100vh - 20px);
    display: flex;
    border: none;
    overflow: hidden;
    // 去除滚动条
    &::-webkit-scrollbar {
      display: none;
    }
    .el-submenu__icon-arrow{
      display: none;
    }
  }
  </style>
  